<script setup lang="ts"></script>
<template>
  <div class="tw-animate-pulse-slow tw-space-y-4">
    <!-- Title -->
    <div class="tw-space-y-2">
      <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/3"></div>
      <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>
    </div>

    <!-- Subheading -->
    <div class="tw-space-y-2">
      <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/3"></div>
      <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>
    </div>

    <!-- Filter by -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-space-y-3 tw-p-2 tw-bg-connx-grey-tint-90 tw-rounded">
      <div v-for="i in 2" :key="'filter-' + i" class="tw-h-10 tw-bg-connx-grey-tint-80 tw-rounded"></div>
    </div>

    <!-- Group by -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>

    <!-- Order by -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>

    <!-- Results -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>

    <!-- Benchmark -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>

    <!-- Benchmark -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-h-10 tw-bg-connx-grey-tint-90 tw-rounded"></div>

    <!-- Visual Type -->
    <div class="tw-h-5 tw-bg-connx-grey-tint-60 tw-rounded tw-w-1/4 tw-mt-6"></div>
    <div class="tw-flex tw-gap-4 tw-flex-wrap tw-mt-2">
      <div v-for="i in 6" :key="'icon-' + i" class="tw-w-20 tw-h-20 tw-rounded-md tw-bg-connx-grey-tint-80"></div>
    </div>
  </div>
</template>
